// src/components/Button.js
import styled, { css } from 'styled-components';
import { colors, ease, duration, fontWeights, radii, space, fontSizes } from '../styles/tokens';

const baseCss = css`
  display: inline-flex;
  align-items: center;
  gap: ${space[1]};
  padding: ${space[2]} ${space[3]};
  border-radius: ${radii.md};
  font-weight: ${fontWeights.semibold};
  font-size: ${fontSizes.sm};
  text-decoration: none;
  border: 1px solid transparent;
  min-height: 44px;
  cursor: pointer;
  transition: background ${duration.fast} ${ease.soft},
              color ${duration.fast} ${ease.soft},
              border-color ${duration.fast} ${ease.soft},
              box-shadow ${duration.fast} ${ease.soft},
              transform ${duration.fast} ${ease.springy};
`;

const primaryCss = css`
  background: ${colors.accent};
  color: ${colors.bg};
  border-color: ${colors.accent};
  &:hover { box-shadow: ${({ theme }) => theme?.glow || '0 0 18px rgba(100,255,218,0.35)'}; }
`;

const ghostCss = css`
  background: transparent;
  color: ${colors.accent};
  border-color: ${colors.accent};
  &:hover { background: rgba(100, 255, 218, 0.08); }
`;

export const Button = styled.button`
  ${baseCss}
  ${(p) => (p.$variant === 'ghost' ? ghostCss : primaryCss)}
`;

export const ButtonLink = styled.a`
  ${baseCss}
  ${(p) => (p.$variant === 'ghost' ? ghostCss : primaryCss)}
`;
